<template>
  <div class="appEntry">
    <p class="text-h6">食事バッチリ！アプリチャレンジコース（略：アプリチャレンジコース）</p>
    <v-alert
      v-if="isAlreadyEntry"
      border="left"
      colored-border
      type="warning"
      elevation="1"
      style="font-size: 90%"
      class="my-6"
    >
      現在、アプリチャレンジコース
      <b v-if="appStatus === 'Temporary'">仮登録中</b>
      <b v-else-if="appStatus === 'Waiting'">キャンセル待ち</b>
      <b v-else-if="appStatus === 'Completion'">登録完了</b>
      です。
    </v-alert>
    <div class="rounded-pill py-2 px-5 mb-4 info--text" align="center" style="border: solid 3px">
      <b>
        必ずご確認ください
        <a href="https://youtu.be/RnhyWN9aNBE" target="_blank" class="ml-2 info--text">アプリチャレンジコース説明動画</a>
      </b>
    </div>
    <span class="red--text">
      <b>
        <span>アプリチャレンジコース参加手順が昨年から変更されています。必ず手順をご確認ください。</span>
        <span style="display: inline-block;">
          <v-btn @click="pdfForManual()" small color="error" class="ml-2">参加手順（PDF）</v-btn>
          <v-btn @click="pdfForForgotPassword()" small color="error" class="ml-2">パスワードを忘れた方</v-btn>
        </span>
      </b>
    </span>
    <v-alert
      border="left"
      colored-border
      type="info"
      elevation="1"
      style="font-size: 90%"
      class="my-6"
    >
      <h4 style="margin-bottom: 1rem;">注意事項</h4>
      <ul style="margin-bottom: 2rem;">
        <li>カロママプラスのアプリをご自身のスマートフォンに入れていただく必要があります。</li>
        <li>このコース以外に、5コース選択可能です。</li>
        <li>このコースは、チーム戦ポイント集計の対象外です。（このコースのみ選択した場合は、チーム員になれません）</li>
      </ul>
      <h4 style="margin-bottom: 1rem;">アプリの詳細については、下記のリンクをご確認下さい</h4>
      <p>
        <span style="width:180px; display:inline-block;">インストール手順</span>
        <a href="https://youtu.be/cvlNFcI6s10" target="_blank">アプリダウンロード（iPhone・Android）</a> /
        <a href="https://youtu.be/1Aeu-oAzV8E" target="_blank">初期登録</a>
      </p>
      <p>
        <span style="width:180px; display:inline-block;">入力方法</span>
        <a href="https://youtu.be/m_ROfiPbt-s" target="_blank">食事入力～基礎編～</a> /
        <a href="https://youtu.be/OC8FVsObnuI" target="_blank">食事入力～便利な入力編～</a> /
        <a href="https://youtu.be/AgWO29EqgxM" target="_blank">運動入力</a> /
        <a href="https://youtu.be/OAmalYMWbbU" target="_blank">カラダ・睡眠・気分入力</a>
      </p>
    </v-alert>
    <div class="text-center">
      <v-btn
        type="submit"
        v-if="!isAlreadyEntry && !isLoading"
        :loading="isSubmitting"
        @click="entry"
        depressed
        class="mt-4"
        color="primary"
      >
        仮登録へ進む
      </v-btn>
    </div>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import dayjs from 'dayjs'

const entryApplicationMutation = (campaignId) => `
  mutation entryApplication {
    entryApplication (campaign_id: "${campaignId}")
  }
`
const entryApplication = async (campaignId) => {
  const { data: { entryApplication: data } } = await GraphqlAPI(entryApplicationMutation(campaignId))
  return data
}

const checkAppUserStatusQuery = (campaignId) => `
  query checkAppUserStatus {
    checkAppUserStatus (campaign_id: "${campaignId}")
  }
`
const checkAppUserStatus = async (campaignId) => {
  const { data: { checkAppUserStatus: data } } = await GraphqlAPI(checkAppUserStatusQuery(campaignId))
  return data
}

export default {
  name: 'app_entry',
  data () {
    return {
      isLoading: false,
      isSubmitting: false,
      isAlreadyEntry: false,
      appStatus: null
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    }
  },
  async created () {
    if (!this.campaign.id) {
      await this.$store.dispatch('initCampaign')
    }
    this.isLoading = true
    this.appStatus = await checkAppUserStatus(this.campaign.id)
    if (this.appStatus === 'Temporary' || this.appStatus === 'Waiting' || this.appStatus === 'Completion') {
      this.isAlreadyEntry = true
    } else {
      this.isAlreadyEntry = false
    }
    this.isLoading = false
  },
  methods: {
    async entry () {
      try {
        const isAppEntryPeriod = dayjs() < dayjs(this.campaign.app_deadline_date, 'YYYY-MM-DD').add(15, 'hour')
        if (!isAppEntryPeriod) {
          this.$emit('errorHandling', '食事バッチリ！アプリチャレンジコースの募集期限が終了したため、エントリーすることが出来ませんでした。')
          return false
        }
        this.isSubmitting = true
        await entryApplication(this.campaign.id)
        const appEntryStatus = await checkAppUserStatus(this.campaign.id)
        this.$store.dispatch('setAppEntryStatus', appEntryStatus)
        this.isSubmitting = false
        this.$router.push({
          name: 'result',
          params: { referer: 'app_entry' }
        }, () => {})
      } catch (e) {
        this.$emit('errorHandling', 'エントリーに失敗しました。')
        this.isSubmitting = false
      }
    },
    pdfForAleadyUser () {
      window.open('/app_challenge/for_already_user.pdf', '_blank')
    },
    pdfForManual () {
      window.open('/app_challenge/manual.pdf', '_blank')
    },
    pdfForForgotPassword () {
      window.open('/app_challenge/forgot_password.pdf', '_blank')
    }
  }
}
</script>
